import {
  GET_EXAM_ROOMS,
  GET_EXAM_ROOMS_FAIL,
  GET_EXAM_ROOMS_SUCCESS,
  ADD_NEW_EXAM_ROOM,
  ADD_EXAM_ROOM_SUCCESS,
  ADD_EXAM_ROOM_FAIL,
  UPDATE_EXAM_ROOM,
  UPDATE_EXAM_ROOM_SUCCESS,
  UPDATE_EXAM_ROOM_FAIL,
  DELETE_EXAM_ROOM,
  DELETE_EXAM_ROOM_SUCCESS,
  DELETE_EXAM_ROOM_FAIL,
  RESET_EXAM_ROOM_LAST_ACTION_SUCCESS,

  CHECK_EXAM_ROOM_AVAILABILITY, 
  CHECK_EXAM_ROOM_AVAILABILITY_SUCCESS, 
  CHECK_EXAM_ROOM_AVAILABILITY_FAIL,


  
} from "./actionTypes";

export const getExamRooms = () => ({
  type: GET_EXAM_ROOMS,
})

export const getExamRoomsSuccess = examRooms => ({
  type: GET_EXAM_ROOMS_SUCCESS,
  payload: examRooms,
})

export const getExamRoomsFail = error => ({
  type: GET_EXAM_ROOMS_FAIL,
  payload: error,
})

export const addNewExamRoom = data => ({
  type: ADD_NEW_EXAM_ROOM,
  payload: data,
})

export const addExamRoomSuccess = examRoom => ({
  type: ADD_EXAM_ROOM_SUCCESS,
  payload: examRoom,
})

export const addExamRoomFail = error => ({
  type: ADD_EXAM_ROOM_FAIL,
  payload: error,
})

export const updateExamRoom = (examRoom) => ({
  type: UPDATE_EXAM_ROOM,
  payload: examRoom,
})

export const updateExamRoomSuccess = (examRoom) => ({
  type: UPDATE_EXAM_ROOM_SUCCESS,
  payload: examRoom,
})

export const updateExamRoomFail = error => ({
  type: UPDATE_EXAM_ROOM_FAIL,
  payload: error,
})

export const deleteExamRoom = data => ({
  type: DELETE_EXAM_ROOM,
  payload: data,
})

export const deleteExamRoomSuccess = data => ({
  type: DELETE_EXAM_ROOM_SUCCESS,
  payload: data,
})

export const deleteExamRoomFail = error => ({
  type: DELETE_EXAM_ROOM_FAIL,
  payload: error,
})

// ─── Disponibilité ────────────────────────────────────────────────────────────
export const checkExamRoomAvailability = (data)  => ({ 
    type: CHECK_EXAM_ROOM_AVAILABILITY,
    payload: data 
});
export const checkExamRoomAvailabilitySuccess = (data)  => ({ 
    type: CHECK_EXAM_ROOM_AVAILABILITY_SUCCESS,  
    payload: data 
});
export const checkExamRoomAvailabilityFail = (error) => ({ 
    type: CHECK_EXAM_ROOM_AVAILABILITY_FAIL,     
    payload: error 
});

export const resetExamRoomLastActionSuccess = () => ({
    type: RESET_EXAM_ROOM_LAST_ACTION_SUCCESS,
});

